import React, { useState } from 'react';

import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import Page from 'components/Page';
import { julo, Typography } from '@julo-ui/react';

import { pageBackground, privyContainer } from './styles';
import NewSubHeader from 'components/NewSubHeader';
import {
  CheckCircle,
  Logo,
  PrivyLogo,
  SwitchIcon,
} from '@new-components/shapes';
import TermCondition from './components/TermCondition';

const PrivyRegistration = () => {
  const history = useHistory();

  const [showTermCondition, setShowTermCondition] = useState(false);

  return (
    <>
      <Helmet>
        <title>JULO - Ringkasan Perjanjian</title>
      </Helmet>
      <Page useHeader={true} className={pageBackground}>
        <NewSubHeader
          title='Daftar TTD Elektronik di Privy'
          onClickBack={() => history.push('/agreement_summary')}
        />
        <julo.div className={privyContainer}>
          <julo.div className='blue-card' />
          <julo.div className='card'>
            <julo.div className='header'>
              <Logo dark={false} width={70} />
              <SwitchIcon />
              <PrivyLogo />
            </julo.div>
            <Typography
              type='body'
              bold
              fontSize='1.1rem'
              sx={{ marginBottom: '12px' }}
            >
              Tanda Tangan Elektronik dengan Privy
            </Typography>
            <Typography
              type='body'
              color='var(--colors-neutrals-80)'
              size='small'
            >
              Sebagai salah satu syarat transaksi, kamu perlu melakukan tanda
              tangan elektronik. Halaman ini hanya digunakan untuk konfirmasi
              bahwa kamu setuju dengan:
            </Typography>
            <julo.div className='flex'>
              <julo.div className='flex-col'>
                <CheckCircle
                  width={20}
                  height={20}
                  fill='var(--colors-green-40)'
                />
                <Typography
                  type='body'
                  color='var(--colors-neutrals-80)'
                  size='small'
                >
                  JULO akan mengirim data ke Privy <strong>hanya</strong> untuk
                  mendaftar tanda tangan elektronik
                </Typography>
              </julo.div>
              <julo.div className='flex-col'>
                <CheckCircle
                  width={20}
                  height={20}
                  fill='var(--colors-green-40)'
                />
                <Typography
                  type='body'
                  color='var(--colors-neutrals-80)'
                  size='small'
                >
                  Proses ini hanya dilakukan <strong>sekali saja</strong>
                </Typography>
              </julo.div>
            </julo.div>
            <julo.div className='footer'>
              <Typography
                type='body'
                color='var(--colors-neutrals-80)'
                size='small'
              >
                Dengan lanjut, kamu menyetujui{' '}
                <span onClick={() => setShowTermCondition(true)}>
                  Syarat & Ketentuan
                </span>{' '}
                untuk hubungkan akun JULO
              </Typography>
            </julo.div>
          </julo.div>
        </julo.div>
      </Page>

      <TermCondition
        isOpen={showTermCondition}
        onClose={() => setShowTermCondition(false)}
      />
    </>
  );
};

export default PrivyRegistration;
